import React from 'react';
import { ToolbarProps } from 'react-big-calendar';
import './dlmCalendar.css';

const CustomCalendarToolbar: React.FC<ToolbarProps> = ({ label, onNavigate }) => {
  return (
    <div className="custom-calendar-toolbar">
      <button onClick={() => onNavigate('PREV')}>{'<'}</button>
      <span>{label}</span>
      <button onClick={() => onNavigate('NEXT')}>{'>'}</button>
    </div>
  );
};

export default CustomCalendarToolbar;
